import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import Close from '@mui/icons-material/Close'
import { Button, IconButton } from '@mui/material'
import { getNextVisitDateDifference } from 'src/mentor/components/commonReportComponents/utils/nextVisitRosterCalendarUtils'

const DialogHeader = ({
  currentView,
  selectedDate,
  bookingDate,
  isBookingLoading,
  onBackToCalendar,
  onSkip,
  nextVisitHoldSlotOmissionReason,
  setNextVisitHoldSlotOmissionReason,
  holdSlotOmissionDialog,
  onContinueWithDateOnly,
}) => {

  return (
    <>
      <div className="d-flex justify-content-between align-items-center" style={{ minHeight: 'auto', lineHeight: 1.2 }}>
        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
          {currentView === 'confirmation' && (
            <IconButton onClick={onBackToCalendar} size="small" sx={{ padding: '4px' }}>
              <ArrowBack fontSize="small" />
            </IconButton>
          )}
          <div>
            <div style={{ fontSize: '1rem', fontWeight: 'bold', lineHeight: 1.2 }}>
              {currentView === 'calendar' ? 'Hold Slot For Next Visit' : 'Confirm & Book'}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center" style={{ gap: '4px' }}>
          {currentView === 'calendar' && selectedDate && onContinueWithDateOnly && (
            <Button
              variant="outlined"
              color="inherit"
              onClick={onContinueWithDateOnly}
              disabled={!selectedDate || isBookingLoading}
              size="small"
              sx={{ 
                padding: '4px 12px',
                fontSize: '0.75rem',
                minWidth: 'auto',
                textTransform: 'none',
                borderColor: '#d0d0d0',
                color: '#666',
                '&:hover': {
                  borderColor: '#999',
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              Date Only
            </Button>
          )}
          <Button
            color="emrPrimary"
            endIcon={<ArrowForward fontSize="small" />}
            disabled={isBookingLoading}
            onClick={() => holdSlotOmissionDialog?.show()}
            size="small"
            sx={{ 
              padding: '4px 12px',
              fontSize: '0.875rem',
              minWidth: 'auto',
            }}
          >
            Skip
          </Button>
          <IconButton 
            disabled={isBookingLoading} 
            onClick={() => onSkip()}
            size="small"
            sx={{ padding: '4px' }}
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
      </div>
    </>
  )
}

export default DialogHeader
